/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ViewBalanceResponse } from '../models/ViewBalanceResponse';
import type { ViewEntityStatementResponse } from '../models/ViewEntityStatementResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class TreasuryService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns ViewEntityStatementResponse OK
     * @throws ApiError
     */
    public viewStatement1({
        page,
        size,
        ownerId,
        ownerType,
        status,
        search,
        startDate,
        endDate,
        sortOrder,
    }: {
        page: number,
        size: number,
        ownerId: string,
        ownerType: 'SHOP' | 'REVENUE' | 'THIRD_PARTY' | 'CLEARING' | 'BANKS' | 'FINANCIER',
        status?: 'SUCCESS' | 'FAILED' | 'PENDING',
        search?: string,
        startDate?: string,
        endDate?: string,
        sortOrder?: string,
    }): CancelablePromise<ViewEntityStatementResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/entity-treasury/statement',
            query: {
                'status': status,
                'search': search,
                'startDate': startDate,
                'endDate': endDate,
                'sortOrder': sortOrder,
                'page': page,
                'size': size,
                'ownerId': ownerId,
                'ownerType': ownerType,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns ViewBalanceResponse OK
     * @throws ApiError
     */
    public viewBalance1({
        ownerId,
        ownerType,
        currency,
        type,
    }: {
        ownerId: string,
        ownerType: 'SHOP' | 'REVENUE' | 'THIRD_PARTY' | 'CLEARING' | 'BANKS' | 'FINANCIER',
        currency?: string,
        type?: string,
    }): CancelablePromise<ViewBalanceResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/entity-treasury/statement/balance',
            query: {
                'ownerId': ownerId,
                'ownerType': ownerType,
                'currency': currency,
                'type': type,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
